// ui.js — storefront interactions (cart drawer, mobile menu, logo, hero, reveals, promo)
(function () {
  function openDrawer() {
    document.querySelector(".scrim")?.setAttribute("data-open", "1");
    document.querySelector(".drawer")?.setAttribute("data-open", "1");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    document.querySelector(".scrim")?.setAttribute("data-open", "0");
    document.querySelector(".drawer")?.setAttribute("data-open", "0");
    document.body.style.overflow = "";
  }
  function openSearch() {
    var so = document.querySelector(".search-overlay");
    if (!so) return;
    so.setAttribute("data-open", "1");
    document.body.style.overflow = "hidden";
    var inp = so.querySelector("input");
    if (inp) setTimeout(function () { inp.focus(); }, 60);
  }
  function closeSearch() {
    var so = document.querySelector(".search-overlay");
    if (!so) return;
    so.setAttribute("data-open", "0");
    document.body.style.overflow = "";
  }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-open-cart]")) { e.preventDefault(); openDrawer(); }
    if (e.target.closest("[data-close-cart]") || e.target.classList.contains("scrim")) closeDrawer();
    if (e.target.closest("[data-open-search]")) { e.preventDefault(); openSearch(); }
    if (e.target.closest("[data-close-search]") || e.target.classList.contains("search-overlay")) closeSearch();
    if (e.target.closest("[data-shop]")) { e.preventDefault(); openChooser(); }
    if (e.target.closest("[data-close-chooser]") || e.target.classList.contains("cat-chooser")) closeChooser();
    const m = e.target.closest("[data-toggle-menu]");
    if (m) {
      const nav = document.querySelector(".nav");
      if (nav) nav.style.display = nav.style.display === "flex" ? "" : "flex";
    }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeDrawer(); closeSearch(); closeChooser(); } });

  // ── category chooser overlay (on 'Comprar ahora') ───────────────────
  var CATS = [
    { href: "/collections/hombre",     name: "Hombre",     img: "https://images.unsplash.com/photo-1516257984-b1b4d707412e?w=600&q=82&auto=format&fit=crop" },
    { href: "/collections/mujer",      name: "Mujer",      img: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=600&q=82&auto=format&fit=crop" },
    { href: "/collections/ninos",      name: "Niños",      img: "https://images.unsplash.com/photo-1503944583220-79d8926ad5e2?w=600&q=82&auto=format&fit=crop" },
    { href: "/collections/accesorios", name: "Accesorios", img: "https://images.unsplash.com/photo-1611652022419-a9419f74343d?w=600&q=82&auto=format&fit=crop" }
  ];
  function ensureChooser() {
    var ex = document.querySelector(".cat-chooser");
    if (ex) return ex;
    var el = document.createElement("div");
    el.className = "cat-chooser";
    el.setAttribute("data-cat-chooser", "");
    el.setAttribute("data-open", "0");
    el.innerHTML =
      '<div class="cat-wrap">' +
        '<div class="cat-top"><span class="cat-q">¿Qué buscas hoy?</span>' +
        '<button class="cat-close" data-close-chooser aria-label="Cerrar">✕</button></div>' +
        '<div class="cat-grid">' +
          CATS.map(function (c, i) {
            return '<a class="cat-panel" style="--d:' + i + '" href="' + c.href + '">' +
              '<img src="' + c.img + '" alt="' + c.name + '" />' +
              '<span class="cat-meta"><span class="cat-name">' + c.name + '</span>' +
              '<span class="cat-go">Comprar →</span></span></a>';
          }).join("") +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    return el;
  }
  function openChooser() {
    var el = ensureChooser();
    el.setAttribute("data-open", "0");
    void el.offsetWidth;
    el.setAttribute("data-open", "1");
    document.body.style.overflow = "hidden";
  }
  function closeChooser() {
    var el = document.querySelector(".cat-chooser");
    if (!el) return;
    el.setAttribute("data-open", "0");
    document.body.style.overflow = "";
  }

  // ── header logo: hanger draws, wordmark fades up ────────────────────
  function animateLogo() {
    var brand = document.querySelector(".site-header .brand");
    if (!brand || brand.dataset.built) return;
    brand.dataset.built = "1";
    requestAnimationFrame(function () { brand.classList.add("draw"); });
  }

  // ── header dropdown menus (account / wishlist / cart) ───────────────
  function dropdowns() {
    var menus = [].slice.call(document.querySelectorAll(".hdr-menu"));
    if (!menus.length) return;
    function closeAll(except) {
      menus.forEach(function (m) { if (m !== except) m.setAttribute("data-open", "0"); });
    }
    menus.forEach(function (m) {
      var btn = m.querySelector("[data-menu-btn]");
      if (!btn) return;
      btn.addEventListener("click", function (e) {
        if (btn.tagName === "A") return; // links navigate; only buttons toggle
        e.preventDefault();
        var open = m.getAttribute("data-open") === "1";
        closeAll(m);
        m.setAttribute("data-open", open ? "0" : "1");
      });
    });
    document.addEventListener("click", function (e) {
      if (!e.target.closest(".hdr-menu")) closeAll(null);
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(null); });
  }

  // ── hero split: reveal big logo entrance ────────────────────────────
  function revealHero() {
    var hs = document.querySelector(".hero-split");
    if (hs) hs.classList.add("in");
  }

  // ── intro splash: logo draws in once per visit ──────────────────────
  function intro() {
    var el = document.getElementById("intro");
    if (!el) { return; }
    var KEY = "trendelo:intro:v1", seen = false;
    try { seen = sessionStorage.getItem(KEY) === "1"; } catch (e) {}
    function finish() {
      if (el.dataset.done) return;
      el.dataset.done = "1";
      el.classList.add("lift");
      document.body.classList.remove("intro-lock");
      revealHero();
      try { sessionStorage.setItem(KEY, "1"); } catch (e) {}
      setTimeout(function () { if (el.parentNode) el.remove(); }, 800);
    }
    if (seen) { el.remove(); revealHero(); return; }
    document.body.classList.add("intro-lock");
    requestAnimationFrame(function () { el.classList.add("go"); });
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    setTimeout(finish, reduce ? 1100 : 2800);
    el.addEventListener("click", finish);
  }

  // ── coming-soon product treatment + Avísame ─────────────────────────
  function comingSoon() {
    if (!document.body.classList.contains("coming-soon")) return;
    [].slice.call(document.querySelectorAll(".pcard")).forEach(function (card) {
      if (card.dataset.coming) return;
      card.dataset.coming = "1";
      card.classList.add("coming");
      var thumb = card.querySelector(".thumb");
      var nameEl = card.querySelector(".name");
      var name = nameEl ? nameEl.textContent.trim() : "esta prenda";
      if (thumb) {
        var badge = document.createElement("span");
        badge.className = "soon-badge"; badge.textContent = "Pr\u00f3ximamente";
        var veil = document.createElement("div");
        veil.className = "soon-veil"; veil.innerHTML = "<span>Pr\u00f3ximamente</span>";
        thumb.appendChild(badge); thumb.appendChild(veil);
        var qa = thumb.querySelector(".quickadd");
        if (qa) { qa.classList.remove("quickadd"); qa.classList.add("coming-cta"); }
        else { qa = document.createElement("div"); qa.className = "coming-cta"; thumb.appendChild(qa); }
        qa.textContent = "Av\u00edsame";
      }
      var info = card.querySelector(".pinfo");
      if (info && !info.querySelector(".soon-price")) {
        var sp = document.createElement("span");
        sp.className = "soon-price"; sp.textContent = "Disponible pronto";
        var priceEl = info.querySelector(".price");
        if (priceEl) priceEl.parentNode.insertBefore(sp, priceEl.nextSibling);
        else info.appendChild(sp);
      }
      card.addEventListener("click", function (e) { e.preventDefault(); openNotify(name); });
    });
  }

  // ── notify ("Avísame") modal ─────────────────────────────────────────
  function ensureNotify() {
    var ex = document.querySelector(".notify-scrim");
    if (ex) return ex;
    var el = document.createElement("div");
    el.className = "notify-scrim"; el.setAttribute("data-open", "0");
    el.innerHTML =
      '<div class="notify" role="dialog" aria-modal="true">' +
        '<button class="nx" data-notify-close aria-label="Cerrar">\u2715</button>' +
        '<div data-notify-main>' +
          '<span class="nk">Pr\u00f3ximamente</span>' +
          '<h4>Av\u00edsame cuando llegue</h4>' +
          '<p>D\u00e9janos tu correo y ser\u00e1s de los primeros en saber cuando <b data-notify-prod>esta prenda</b> est\u00e9 disponible.</p>' +
          '<form class="notify-form" data-notify-form novalidate>' +
            '<input type="email" placeholder="Correo electr\u00f3nico" aria-label="Correo" required />' +
            '<button class="btn btn--accent btn--lg btn--block" type="submit">Av\u00edsame</button>' +
          '</form>' +
        '</div>' +
        '<div class="notify-done" data-notify-done hidden>' +
          '<svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg>' +
          '<h4>\u00a1Hecho!</h4>' +
          '<p style="margin:0">Te avisaremos en cuanto est\u00e9 disponible.</p>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    return el;
  }
  function openNotify(prod) {
    var el = ensureNotify();
    el.querySelector("[data-notify-prod]").textContent = prod || "esta prenda";
    el.querySelector("[data-notify-main]").hidden = false;
    el.querySelector("[data-notify-done]").hidden = true;
    var form = el.querySelector("[data-notify-form]"); if (form) form.reset();
    el.setAttribute("data-open", "1");
    document.body.style.overflow = "hidden";
    var inp = el.querySelector("input"); if (inp) setTimeout(function () { inp.focus(); }, 80);
  }
  function closeNotify() {
    var el = document.querySelector(".notify-scrim"); if (!el) return;
    el.setAttribute("data-open", "0"); document.body.style.overflow = "";
  }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-notify-close]") || e.target.classList.contains("notify-scrim")) closeNotify();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeNotify(); });
  document.addEventListener("submit", function (e) {
    var f = e.target.closest("[data-notify-form]");
    if (!f) return;
    e.preventDefault();
    var inp = f.querySelector("input"), v = (inp && inp.value || "").trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { inp.style.borderColor = "#c0392b"; inp.focus(); return; }
    var scrim = f.closest(".notify-scrim");
    scrim.querySelector("[data-notify-main]").hidden = true;
    scrim.querySelector("[data-notify-done]").hidden = false;
    setTimeout(closeNotify, 1800);
  });

  // ── hero slideshow: cinematic clip-wipe + Ken Burns ─────────────────
  function heroShow() {
    var track = document.querySelector(".hero-media .slides");
    if (!track) return;
    var slides = [].slice.call(track.querySelectorAll(".slide"));
    var dots = [].slice.call(document.querySelectorAll(".hero-dots .dot"));
    if (slides.length < 2) return;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var i = -1, z = 1, timer = null;
    function go(n) {
      var idx = (n + slides.length) % slides.length;
      if (idx === i) return;
      i = idx;
      var s = slides[i];
      if (reduce) {
        slides.forEach(function (x) { x.style.clipPath = "inset(0 0 0 100%)"; });
        s.style.clipPath = "inset(0 0 0 0)"; s.style.zIndex = (++z);
      } else {
        s.style.transition = "none";
        s.style.clipPath = "inset(0 0 0 100%)";
        void s.offsetWidth;
        s.style.transition = "";
        s.style.zIndex = (++z);
        requestAnimationFrame(function () { s.style.clipPath = "inset(0 0 0 0)"; });
        s.classList.remove("kb"); void s.offsetWidth; s.classList.add("kb");
      }
      dots.forEach(function (d, k) { d.classList.toggle("active", k === i); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); if (!reduce) timer = setInterval(function () { go(i + 1); }, 4800); }
    dots.forEach(function (d, idx) { d.addEventListener("click", function () { go(idx); start(); }); });
    var media = document.querySelector(".hero-media");
    if (media) { media.addEventListener("mouseenter", stop); media.addEventListener("mouseleave", start); }
    go(0); start();
  }

  // ── hero headline: word-by-word mask rise ───────────────────────────
  function animateHeadline() {
    var h = document.querySelector(".hero h1");
    var hero = document.querySelector(".hero");
    if (!h || !hero || h.dataset.split) return;
    h.dataset.split = "1";
    var words = [];
    [].forEach.call(h.childNodes, function (node) {
      if (node.nodeType === 3) {
        node.textContent.split(/\s+/).forEach(function (w) { if (w) words.push({ t: w, ital: false }); });
      } else if (node.nodeType === 1) {
        var ital = node.classList && node.classList.contains("ital");
        node.textContent.split(/\s+/).forEach(function (w) { if (w) words.push({ t: w, ital: ital }); });
      }
    });
    var merged = [];
    words.forEach(function (w) {
      if (/^[.,;:!?\u2026]+$/.test(w.t) && merged.length) merged[merged.length - 1].t += w.t;
      else merged.push(w);
    });
    h.setAttribute("aria-label", merged.map(function (w) { return w.t; }).join(" "));
    h.innerHTML = merged.map(function (w, idx) {
      return '<span class="h-word" style="--wi:' + idx + '"><i' + (w.ital ? ' class="ital"' : '') + '>' + w.t + '</i></span>';
    }).join(" ");
    hero.classList.add("hero-anim");
    requestAnimationFrame(function () { hero.classList.add("play"); });
    setTimeout(function () { hero.classList.add("hero-done"); }, 1800);
  }

  // ── reveal-on-scroll ────────────────────────────────────────────────
  function revealOnScroll() {
    var els = [].slice.call(document.querySelectorAll(".reveal-up"));
    if (!els.length) return;
    document.body.classList.add("has-reveal");
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  // ── discount popup ──────────────────────────────────────────────────
  function promoPopup() {
    var pop = document.querySelector(".promo-pop");
    if (!pop) return;
    var KEY = "trendelo:promo-dismissed";
    function dismiss() { pop.classList.remove("show"); try { localStorage.setItem(KEY, "1"); } catch (e) {} }
    pop.querySelector(".px")?.addEventListener("click", dismiss);
    var seen = false; try { seen = localStorage.getItem(KEY) === "1"; } catch (e) {}
    if (!seen) setTimeout(function () { pop.classList.add("show"); }, 3500);
  }

  // ── scroll showcase: card tilts up on scroll (ContainerScroll-style) ─
  function scrollShowcase() {
    var track = document.querySelector(".showcase-track");
    if (!track) return;
    var card = track.querySelector(".showcase-card");
    var title = track.querySelector(".showcase-title");
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var mobile = window.innerWidth <= 768, ticking = false;
    function update() {
      ticking = false;
      var rect = track.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var p = Math.min(1, Math.max(0, -rect.top / (total || 1)));
      var rot = 20 * (1 - p);
      var scale = mobile ? (0.8 + 0.2 * p) : (1.05 - 0.05 * p);
      if (card) card.style.transform = "rotateX(" + rot + "deg) scale(" + scale + ")";
      if (title) title.style.transform = "translateY(" + (-80 * p) + "px)";
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () { mobile = window.innerWidth <= 768; update(); });
    update();
  }

  function init() { animateLogo(); dropdowns(); intro(); comingSoon(); animateHeadline(); heroShow(); revealOnScroll(); promoPopup(); scrollShowcase(); }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
